var rich_content_viewer_default = {
  "fontElementMap": "GVbfb",
  "wrapper": "gP1LT",
  "pluginContainerMobile": "fTYKn",
  "viewer": "uSmxr",
  "android": "_9n4zS",
  "rootedTraversedContent": "rTi1n",
  "atomic": "WBkHh",
  "toolbar": "ba5lV",
  "block": "TNCsr"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
